import {
    IconAccess,
    IconActivation,
    IconAudit,
    IconFlag,
    IconMigration,
    IconOrgs,
    IconOverview,
    IconShield,
} from '@shared/ui';

import type { ComponentType, SVGProps } from 'react';

export type NavItem = {
    label: string;
    href: string;
    icon: ComponentType<SVGProps<SVGSVGElement>>;
    /** Rendered muted + non-navigable until the screen exists. */
    disabled?: boolean;
    /**
     * An employee-pool permission the item needs (INI-0313). Without it the
     * item is not rendered at all; see `visibleNavGroups`.
     */
    requiresPermission?: string;
};

export type NavGroup = {
    label?: string;
    items: NavItem[];
};

/** Read the unidentified-refusals log. The BFF's guard demands the same string. */
export const UNIDENTIFIED_REFUSALS_READ = 'audit:unidentified-refusals.read';

/** Sidebar structure — matches the Backoffice mockup. */
export const NAV_GROUPS: NavGroup[] = [
    {
        items: [{ label: 'Overview', href: '/overview', icon: IconOverview }],
    },
    {
        label: 'Configuration',
        items: [
            // One entry, not three: Flags, Components and Products are tabs of
            // one screen, because they are one question — what exists on the
            // platform. `Add-ons` used to sit beside this and is now the
            // Products tab; the nav cannot carry both words at once.
            //
            // No counts in this sidebar. The flags badge used to live here and
            // moved onto the catalog's own tabs: a number beside `Catalog`
            // would have to stand for three things at once, and beside `Flags`
            // it means flags.
            { label: 'Catalog', href: '/catalog/flags', icon: IconFlag },
        ],
    },
    {
        label: 'Tenants',
        items: [
            { label: 'Clients', href: '/clients', icon: IconOrgs },
            { label: 'Feature Activation', href: '/activation-tracking', icon: IconActivation },
            { label: 'Salesforce migration', href: '/migrations', icon: IconMigration },
            { label: 'Audit Log', href: '/audit', icon: IconAudit },
        ],
    },
    {
        // Shown only to an employee whose employee-pool session carries the
        // permission; without it the whole group is dropped.
        label: 'Security',
        items: [
            {
                label: 'Unidentified refusals',
                href: '/security/unidentified-refusals',
                icon: IconShield,
                requiresPermission: UNIDENTIFIED_REFUSALS_READ,
            },
        ],
    },
    {
        label: 'System',
        items: [{ label: 'Access & Roles', href: '/access', icon: IconAccess, disabled: true }],
    },
];
